import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUserToken, setIdolId, clearSession } from '@/shared/store/slices/userSlice';
import Loading from '@/components/ui/Loading';

const AuthRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const processAuthRedirect = async () => {
      try {
        // 1. 接收參數：從 URL 取得 token、target、uuid、idolId 參數
        const token = searchParams.get('token');
        const target = searchParams.get('target');
        const uuid = searchParams.get('uuid');
        const adminIdolId = searchParams.get('idol_id');

        // 2. 驗證參數完整性
        if (!token || !target || !uuid || !adminIdolId) {
          console.error('Missing required parameters');
          navigate('/', { replace: true });
          return;
        }

        // 驗證 target 是否為有效值
        const validTargets = ['idol', 'post', 'world'];
        if (!validTargets.includes(target)) {
          console.error('Invalid target parameter');
          navigate('/', { replace: true });
          return;
        }

        // 3. 先清掉現有登入狀態（與登出相同），再用 token 和 idolId 登入。
        // 只覆寫 token、idolId 的話，前一個使用者的 userId、暱稱、偶像列表、聊天室、通知都會留著，
        // WS 也會用舊的 userId 訂閱頻道。後台網址不帶 user_id，清除後 userId 為空，後台登入期間不訂閱 WS
        dispatch(clearSession());
        // 搜尋紀錄存在 localStorage、不跟帳號綁定，比照登出一併移除
        localStorage.removeItem('searchHistory');
        dispatch(setUserToken(token));
        dispatch(setIdolId(parseInt(adminIdolId)));
        // 偶像列表不必在這裡重抓：/auth-redirect 一定是外部整頁載入，App 與本頁在同一次 commit 掛載，
        // App 的掛載 effect 跑在本 effect 之後，getIdolArray 讀 getState() 拿到的已是新 token

        // 4. 頁面導向：根據 target 和 uuid 決定導向位置
        let targetPath = '/';
        switch (target) {
          case 'idol':
            targetPath = `/idol/${uuid}`;
            break;
          case 'post':
            targetPath = `/post/${uuid}`;
            break;
          case 'world':
            targetPath = `/world-view/${uuid}`;
            break;
          default:
            targetPath = '/';
        }

        navigate(targetPath, { replace: true });
      } catch (error) {
        console.error('Auth redirect error:', error);
        // 錯誤處理：導向首頁
        navigate('/', { replace: true });
      } finally {
        setIsProcessing(false);
      }
    };

    processAuthRedirect();
  }, [searchParams, navigate, dispatch]);

  // 處理過程中顯示載入畫面
  if (isProcessing) {
    return <Loading />;
  }

  return null;
};

export default AuthRedirect;